import { getConnectivityOnline } from "@/domains/offline/connectivity/connectivityStore";
import { clearOfflineData } from "@/domains/offline/db/mivoDb";
import { authApi } from "@/domains/shared/apis/authApi";
import { authMeQueryKey } from "@/domains/shared/hooks/useAuth";
import { queryClient } from "@/domains/shared/services/queryClient";
import { resetCsrfToken } from "@/domains/shared/services/setupCsrfInterceptor";
import { SESSION_EXPIRED_TRANSLATIONS } from "@/domains/shared/services/sessionExpiredConstants";
import { getTranslation } from "@mivo/i18n";
import { toast } from "sonner";

export { SESSION_EXPIRED_TRANSLATIONS } from "@/domains/shared/services/sessionExpiredConstants";

export const SESSION_EXPIRED_STORAGE_KEY = "mivo_session_expired";

let handling = false;

/** Routes where an unauthenticated 401 is expected — do not reload/toast session-expired. */
export function isPublicAuthPath(pathname: string): boolean {
    const normalized = pathname.replace(/\/+$/, "") || "/";
    return normalized === "/login"
        || normalized === "/esqueci-senha"
        || normalized.startsWith("/cadastro")
        || normalized.startsWith("/reativar-conta");
}

export function markSessionExpired(): void {
    sessionStorage.setItem(SESSION_EXPIRED_STORAGE_KEY, "1");
}

export function consumeSessionExpired(): boolean {
    const flagged = sessionStorage.getItem(SESSION_EXPIRED_STORAGE_KEY) === "1";

    if (flagged) {
        sessionStorage.removeItem(SESSION_EXPIRED_STORAGE_KEY);
    }

    return flagged;
}

export function getSessionExpiredMessage(): string {
    return getTranslation(SESSION_EXPIRED_TRANSLATIONS.toast);
}

export async function forceLogoutSessionExpired(
    message: string = getSessionExpiredMessage(),
): Promise<void> {
    if (handling) {
        return;
    }

    handling = true;
    try {
        resetCsrfToken();
        queryClient.removeQueries({ queryKey: authMeQueryKey });

        if (isPublicAuthPath(window.location.pathname)) {
            return;
        }

        markSessionExpired();

        if (getConnectivityOnline()) {
            try {
                await authApi.logout();
            } catch {
                /* ignore — refresh 401 already clears HttpOnly cookies server-side */
            }

            await clearOfflineData();
        }

        toast.error(message);
        window.location.assign("/login");
    } finally {
        handling = false;
    }
}
